const GlobalData = {
    Features: [],
    QuoteCQClientCode: '',
    LanguageCode: 'en-US',
};

export default GlobalData;